import { z } from 'zod';
export const ApplicationStatusSchema = z.enum([
    'pending-analysis',
    'pending-guarantor',
    'pending-handoff',
    'pending-acceptance',
    'pending-new-proposal',
    'pending-declarations',
    'pending-declarations-confirmation',
    'pending-signature',
    'pending-disbursement',
    'active',
    'settled',
    'rejected',
    'cancelled',
    'expired',
]);
export const BaseApplicationDTOSchema = z.object({
    id: z.uuid(),
    companyId: z.uuidv7(),
    facilityId: z.uuidv7(),
    personId: z.uuidv7(),
    requestedAmount: z.number().int().positive(),
    firstPaymentDate: z.iso.date(),
    installmentCount: z.number().int().min(1).max(120),
    status: ApplicationStatusSchema,
    celcoinApplicationId: z.string().nullable(),
    handoffReleasedAt: z.coerce.date().nullable(),
    guarantorIds: z.uuidv7().array(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullable(),
    isDeleted: z.boolean(),
});
export const ExposedApplicationDTOSchema = BaseApplicationDTOSchema.omit({
    celcoinApplicationId: true,
    handoffReleasedAt: true,
    isDeleted: true,
    deletedAt: true,
});
//# sourceMappingURL=applications.dto.js.map